import device from "@/core/device";
import { scroller } from "@/core/resource";
import eventTypes from "@/events/event-types";
import store from "@/store";
import types from "@/store/types";
var Body = /** @class */ (function () {
    function Body() {
        console.log("[create] Body");
    }
    Body.prototype.setup = function () {
        var body = document.body;
        body.classList.add(device.isPC ? "is-pc" : "is-sp");
        if (device.isIE) {
            body.classList.add("is-ie");
            if (device.isIE10) {
                body.classList.add("notice_deprecated");
            }
            if (device.isIE9) {
                body.classList.add("notice_deprecated");
            }
        }
        if (device.isEdge) {
            body.classList.add("is-edge");
        }
        if (device.isChrome) {
            body.classList.add("is-chrome");
        }
        if (device.isAndroid) {
            body.classList.add("is-android");
            if (device.version < 5) {
                body.classList.add("notice_deprecated");
            }
        }
        if (device.isIOS) {
            body.classList.add("is-ios");
            if (device.version < 10) {
                body.classList.add("notice_deprecated");
            }
        }
        var sectionMessageElem = document.querySelector(".section--message");
        if (sectionMessageElem) {
            this._sectionMessageElem = sectionMessageElem;
        }
        var toggleMenuElem = document.querySelector(".toggle-menu");
        if (toggleMenuElem) {
            this._toggleMenuElem = toggleMenuElem;
        }
        this._setWatches();
        this._setNativeEvents();
    };
    Body.prototype._setWatches = function () {
        var body = document.body;
        store.watch(types.TRANSITION_PROGRESS, function (_a) {
            var transitionProgress = _a.transitionProgress;
            transitionProgress
                ? body.classList.add("transition-progress")
                : body.classList.remove("transition-progress");
        });
        store.watch(types.ENTER_PROGRESS, function (_a) {
            var enterProgress = _a.enterProgress;
            enterProgress
                ? body.classList.add("enter-progress")
                : body.classList.remove("enter-progress");
        });
        store.watch(types.LEAVE_PROGRESS, function (_a) {
            var leaveProgress = _a.leaveProgress;
            leaveProgress
                ? body.classList.add("leave-progress")
                : body.classList.remove("leave-progress");
        });
        store.watch(types.PAGE_NAME, function (_a) {
            var pageName = _a.pageName;
            body.dataset.pagename = pageName;
        });
        store.watch(types.MENU_OPEN_PROGRESS, function (_a) {
            var menuOpenProgress = _a.menuOpenProgress;
            if (menuOpenProgress) {
                body.classList.add("is-menu-open");
            }
        });
        store.watch(types.MENU_CLOSE_PROGRESS, function (_a) {
            var menuCloseProgress = _a.menuCloseProgress;
            if (!menuCloseProgress) {
                body.classList.remove("is-menu-open");
            }
        });
        store.watch(types.IS_MODAL_OPEN, function (_a) {
            var isModalOpen = _a.isModalOpen;
            isModalOpen
                ? body.classList.add("is-modal-open")
                : body.classList.remove("is-modal-open");
        });
    };
    Body.prototype._setNativeEvents = function () {
        this._onScroll = function () {
            if (0 < scroller.scrollTop) {
                document.body.classList.add("is-menu-visible");
            }
            else {
                document.body.classList.remove("is-menu-visible");
            }
        };
        this._onClickAtToggleMenu = function () {
            document.body.classList.toggle("is-menu-open");
        };
        if (this._sectionMessageElem) {
            scroller.addEventListener(eventTypes.SCROLL, this._onScroll);
        }
        this._toggleMenuElem.addEventListener(eventTypes.CLICK, this._onClickAtToggleMenu);
    };
    /**
     * .section--messageに入ったから調べる
     */
    Body.prototype._checkSectionMessageEnter = function () {
        var scrollTop = scroller.scrollTop;
        var borderLine = this._sectionMessageElem.getBoundingClientRect().top + scrollTop;
        return borderLine < scrollTop;
    };
    return Body;
}());
export default Body;
